import i18n from '@/locale/index'
import * as r_permission from '@/shared/route_permission'
export default {
  items: [
    {
      name:  i18n.t('DASHBOARD'),
      url: '/dashboard',
      icon: 'icon-speedometer',

    },
    {
      name: i18n.t('USERS'),
      url: '/users',
      icon: 'icon-user',
    }

  ]
}
